import * as React from 'react';
import { ListBox, ListBoxItemClickEvent } from '@progress/kendo-react-listbox';
import {
  ConfigRoot,
  ConfigFeature,
  SettingsGroups,
  Settings,
  FieldType,
  FixedChoice,
} from '../../../Interfaces/Config/FeatureInfo';
import { ApplicationState } from '../../../store';
import { GridLayout, GridLayoutItem } from '@progress/kendo-react-layout';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { useEffect } from 'react';
import {
  getConfigFeatures,
  fetchFeatureFileFolderPath,
  uploadFileToServer,
} from '../../../store/Config/Settings/ConfigSettingsActions';
import { Typography } from '@material-ui/core';
import {
  DropDownListChangeEvent,
  MultiSelect,
  MultiSelectChangeEvent,
  ListItemProps,
} from '@progress/kendo-react-dropdowns';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Button } from '@progress/kendo-react-buttons';
import clsx from 'clsx';
import {
  Input,
  ColorPicker,
  ColorPickerChangeEvent,
  InputChangeEvent,
  RangeSlider,
  SliderLabel,
  RangeSliderChangeEvent,
} from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import StringResourceManager, { GetString } from '../../StringResourceManager';
import NodeSelection from '../../NodeSelection';
import {
  SendToDivisionCommandInfo,
  SendToLanesCommandInfo,
  SendToNodeGroupsCommandInfo,
  SendToSiteNumbersCommandInfo,
} from '../../../Interfaces/Commands/CommandInfo';
import {
  sendToDivisionCommand,
  sendToLanesCommand,
  sendToNodeGroupsCommand,
  sendToSiteNumberCommand,
  resetAllSendCommandResult,
} from '../../../store/Assets/AssetsActions';
import { Fade } from '@progress/kendo-react-animation';
import {
  Notification,
  NotificationGroup,
} from '@progress/kendo-react-notification';
import { uploadIcon } from '@progress/kendo-svg-icons';
import { FeatureFileFolderPath } from '../../../Interfaces/Config/FeatureFileFolderPath';
import { Loader } from '@progress/kendo-react-indicators';
import { ServerUploadResult } from '../../../Interfaces/Config/ServerUploadResult';
import { FEAURES_ENTRY_TYPE } from '../../../utils/constants';
import DynamicDropDownList from '../../DynamicDropDownList';

interface FeatureNameListInfo {
  ID: string;
  Name: string;
  Selected: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectedSetting: {
      backgroundColor: '#e4e7eb',
    },
    notSelectedSetting: {
      backgroundColor: 'white',
    },
    settingButton: {
      display: 'flex',
      flex: 1,
      textAlign: 'start',
      height: 33,
      alignItems: 'center',
      border: '1px solid lightgrey',
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
      overflow: 'auto',
    },
    settingButtonLabel: {
      marginLeft: 10,
    },
    settingListContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    fieldComponentContainer: {
      flex: 1,
    },
    featureHeaderLabel: {
      backgroundColor: '#23496B',
      padding: 5,
      color: 'white',
    },
    featureListBox: {
      height: 500,
      width: '100%',
    },
    colorPicker: {
      marginLeft: 10,
    },
    fieldComponent: {
      height: 33,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 5,
      borderTopRightRadius: 5,
      backgroundColor: '#FFF',
    },
    rangeSlider: {
      width: '100%',
      paddingBottom: 20,
    },
    settingDescription: {
      display: 'flex',
      flex: 0.1,
      flexDirection: 'column',
      backgroundColor: '#e4e7eb',
      justifyContent: 'flex-end',
    },
    settingDescriptionHeaderLabel: {
      fontWeight: 'bold',
      fontSize: '1rem',
      padding: 5,
    },
    settingDescriptionLabel: {
      paddingLeft: 5,
      paddingBottom: 5,
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
    },
    featureListBoxContainer: {
      display: 'flex',
      flex: 0.3,
    },
    featureListBoxView: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    settingsGroupContainer: {
      display: 'flex',
      flex: 0.7,
    },
    gridLayout: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    },
    gridLayoutItemSetting: {
      display: 'flex',
      flex: 0.9,
      flexDirection: 'column',
    },
    bottomRight: {
      right: 0,
      bottom: 0,
      alignItems: 'flex-start',
      flexWrap: 'wrap-reverse',
    },
    send: {
      fontSize: '1.5rem',
    },
  }),
);

export const FeaturesNameListBox = () => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  const [featureNameList, setfeatureNameList] = React.useState<
    FeatureNameListInfo[]
  >([]);

  const [selectedFeatureID, setSelectedFeatureID] = React.useState<string>('');

  const [selectedSettingsGroup, setSelectedSettingsGroup] = React.useState<
    SettingsGroups[]
  >([]);

  const [currentFeaturesConfig, setCurrentFeaturesConfig] =
    React.useState<ConfigRoot>({ Features: [] });

  const [currentModifiedConfigFeature, setCurrentModifiedConfigFeature] =
    React.useState<ConfigFeature>({ ID: '', Name: '', SettingsGroups: [] });

  const [modifiedConfigFeatures, setModifiedConfigFeatures] = React.useState<
    ConfigFeature[]
  >([]);

  const [defaultConfigRoot, setDefaultConfigRoot] = React.useState<string>('');

  const [isCommandSentSuccessfully, setIsCommandSentSuccessfully] =
    React.useState<boolean>(false);

  const featureFileFolderPath: FeatureFileFolderPath = useSelector(
    (state: ApplicationState) =>
      state.configSettingsReducer.featureFileFolderPath,
  );

  const fileUploadToServerStatus: ServerUploadResult = useSelector(
    (state: ApplicationState) =>
      state.configSettingsReducer.fileUploadToServerStatus,
  );

  const [selectedFileName, setSelectedFileName] = React.useState<string>('');

  const [notificationMessage, setNotificationMessage] =
    React.useState<string>('');

  const [selectedSetting, setSelectedSetting] = React.useState<Settings>({
    Type: '',
    Name: '',
    ListName: '',
    Description: '',
    InitValue: '',
    FieldType: 0,
    FixedChoices: [],
    MediaName: '',
  });

  const [selectedSettingGroup, setSelectedSettingGroup] =
    React.useState<SettingsGroups>({
      Type: '',
      Name: '',
      ListName: '',
      Destination: '',
      Settings: [],
    });

  const [isFileUploading, setFileUploadingStatus] = React.useState(false);

  const featuresConfig: ConfigRoot = useSelector(
    (state: ApplicationState) => state.configSettingsReducer.featuresConfig,
  );

  const SELECTED_FIELD = 'Selected';

  const fetchServerFolderPath = () => {
    if (featureFileFolderPath.FilePath == '')
      fetchFeatureFileFolderPath(dispatch);
  };

  const sendToSiteNumberResult: string = useSelector(
    (state: ApplicationState) =>
      state.assetsReducer.notificationSendToSiteNumberSuccessMessage,
  );

  const sendToNodeGroupsResult: string = useSelector(
    (state: ApplicationState) =>
      state.assetsReducer.notificationSendToNodeGroupsSuccessMessage,
  );

  const sendToLanesResult: string = useSelector(
    (state: ApplicationState) =>
      state.assetsReducer.notificationSendToLanesSuccessMessage,
  );

  const sendToDivisionResult: string = useSelector(
    (state: ApplicationState) =>
      state.assetsReducer.notificationSendToDivisionSuccessMessage,
  );

  useEffect(() => {
    if (fileUploadToServerStatus.Code == 1) {
      setIsCommandSentSuccessfully(true);
      setNotificationMessage('UPLOAD_COMPLETED');

      if (validateImageFileType(selectedFileName)) {
        updateSetting(
          featureFileFolderPath.FilePath + selectedFileName,
          selectedSetting,
          selectedSettingGroup,
        );
        displayCommandSend(true);
      }
    } else if (fileUploadToServerStatus.Code < 0) {
      setNotificationMessage(fileUploadToServerStatus.Message);

      displayCommandSend(true);
      removeModifiedFeature(currentModifiedConfigFeature);
    } else {
      removeModifiedFeature(currentModifiedConfigFeature);
    }

    setFileUploadingStatus(false);
    return () => {};
  }, [fileUploadToServerStatus]);

  useEffect(() => {
    getConfigFeatures(dispatch);
    fetchServerFolderPath();
    return () => {};
  }, []);

  useEffect(() => {
    if (sendToSiteNumberResult != '')
      displayCommandRequestResult(sendToSiteNumberResult);
    else if (sendToNodeGroupsResult != '')
      displayCommandRequestResult(sendToNodeGroupsResult);
    else if (sendToLanesResult != '')
      displayCommandRequestResult(sendToLanesResult);
    else if (sendToDivisionResult != '')
      displayCommandRequestResult(sendToDivisionResult);
  }, [
    sendToSiteNumberResult,
    sendToNodeGroupsResult,
    sendToLanesResult,
    sendToDivisionResult,
  ]);

  useEffect(() => {
    if (featuresConfig.Features.length > 0) {
      let nameList: FeatureNameListInfo[] = [];
      if (featuresConfig.Features.length > 0) {
        featuresConfig.Features.map((item: ConfigFeature) =>
          nameList.push({ ID: item.ID, Name: item.Name, Selected: false }),
        );

        nameList[0].Selected = true;
        setSelectedSettingsGroup(featuresConfig.Features[0].SettingsGroups);
        setSelectedSetting(
          featuresConfig.Features[0].SettingsGroups[0].Settings[0],
        );
        setSelectedFeatureID(nameList[0].ID);
      }

      setfeatureNameList(nameList);
      setCurrentFeaturesConfig(featuresConfig);
      setDefaultConfigRoot(JSON.stringify(featuresConfig));
    }
    return () => {};
  }, [featuresConfig]);

  const handleFeatureClick = (event: ListBoxItemClickEvent) => {
    let currentState: FeatureNameListInfo[] = featureNameList.map(
      (item: FeatureNameListInfo) => {
        if (item.Name === event.dataItem.Name) {
          item.Selected = !item.Selected;

          let settingsGroupIndex: number =
            currentFeaturesConfig.Features.findIndex(
              (config: ConfigFeature) => config.ID == item.ID,
            );

          setSelectedFeatureID(item.ID);

          if (settingsGroupIndex != -1) {
            setSelectedSettingsGroup(
              currentFeaturesConfig.Features[settingsGroupIndex].SettingsGroups,
            );
            setSelectedSetting(
              currentFeaturesConfig.Features[settingsGroupIndex]
                .SettingsGroups[0].Settings[0],
            );
          }
        } else if (!event.nativeEvent.ctrlKey) {
          item.Selected = false;
        }

        return item;
      },
    );
    setfeatureNameList(currentState);
  };

  const removeModifiedFeature = (configFeature: ConfigFeature) => {
    let result: ConfigFeature[] = modifiedConfigFeatures.filter(
      (c: ConfigFeature) => c.ID != configFeature.ID,
    );

    setModifiedConfigFeatures(result);
  };

  const removeUnchangedSettings = (result: ConfigFeature[]) => {
    for (let featureIndex = 0; featureIndex < result.length; featureIndex++) {
      for (
        let settingsGroupIndex = 0;
        settingsGroupIndex < result[featureIndex].SettingsGroups.length;
        settingsGroupIndex++
      ) {
        let modifiedSettings: Settings[] = [];
        for (
          let settingIndex = 0;
          settingIndex <
          result[featureIndex].SettingsGroups[settingsGroupIndex].Settings
            .length;
          settingIndex++
        ) {
          let settingInfo =
            result[featureIndex].SettingsGroups[settingsGroupIndex].Settings[
              settingIndex
            ];

          if (!settingInfo.InitValue) continue;

          if (
            settingInfo.Type == FEAURES_ENTRY_TYPE.RegEntryDword &&
            (settingInfo.FieldType == FieldType.FixedChoice ||
              settingInfo.FieldType == FieldType.RadioButton)
          ) {
            if (isNaN(Number(settingInfo.InitValue))) {
              let value = settingInfo.FixedChoices.find(
                (choice: FixedChoice) =>
                  choice.FixedChoiceValue == settingInfo.InitValue,
              )?.Value;
              if (value) {
                settingInfo.InitValue = value;
              }
            }
          }

          settingInfo.FixedChoices = [];
          modifiedSettings.push(settingInfo);
        }
        result[featureIndex].SettingsGroups[settingsGroupIndex].Settings =
          modifiedSettings;
        if (modifiedSettings.length == 0)
          result[featureIndex].SettingsGroups.splice(settingsGroupIndex, 1);
      }
    }

    return result;
  };

  const updateModifiedFeatures = (
    configFeature: ConfigFeature,
    featureIndex: number,
  ) => {
    let configFeatureCopy: ConfigFeature = JSON.parse(
      JSON.stringify(configFeature),
    );
    let defaultConfig: ConfigRoot = JSON.parse(defaultConfigRoot);

    let result: ConfigFeature[] = modifiedConfigFeatures.filter(
      (c: ConfigFeature) => c.ID != configFeatureCopy.ID,
    );

    if (
      JSON.stringify(defaultConfig.Features[featureIndex]) !=
      JSON.stringify(configFeatureCopy)
    ) {
      result.push(configFeatureCopy);
    }

    result = removeUnchangedSettings(result);

    setModifiedConfigFeatures(result);
  };

  const updateSetting = (
    value: any,
    setting: Settings,
    settingGroup: SettingsGroups,
  ) => {
    let selectedFeatureIndex: number = currentFeaturesConfig.Features.findIndex(
      (cf: ConfigFeature) => cf.ID == selectedFeatureID,
    );
    let selectedSettingGroupIndex: number = selectedSettingsGroup.findIndex(
      (sg: SettingsGroups) =>
        sg.Name == settingGroup.Name && sg.ListName == settingGroup.ListName,
    );
    let selectedSettingIndex: number = selectedSettingsGroup[
      selectedSettingGroupIndex
    ].Settings.findIndex(
      (s: Settings) => s.Name == setting.Name && s.ListName == setting.ListName,
    );
    if (selectedSettingIndex != -1) {
      let updateFeatures: ConfigRoot = { ...currentFeaturesConfig };

      updateFeatures.Features[selectedFeatureIndex].SettingsGroups[
        selectedSettingGroupIndex
      ].Settings[selectedSettingIndex].InitValue = value;

      setSelectedSettingsGroup(
        updateFeatures.Features[selectedFeatureIndex].SettingsGroups,
      );

      setCurrentFeaturesConfig(updateFeatures);

      setCurrentModifiedConfigFeature(
        updateFeatures.Features[selectedFeatureIndex],
      );

      updateModifiedFeatures(
        updateFeatures.Features[selectedFeatureIndex],
        selectedFeatureIndex,
      );
    }
  };

  const [checkBoxState, setCheckBoxState] = React.useState<any>({
    value: [],
    allSelected: true,
  });

  const handleCheckBoxMultiSelectChange = (event: MultiSelectChangeEvent) => {
    let value = event.value;
    setCheckBoxState({ value });
  };

  const isImage = ['png', 'PNG'];

  const validateInputFileType = (fileName: string) => {
    if (selectedSetting.Type == 'Image') {
      return validateImageFileType(fileName);
    }
    return false;
  };

  const validateImageFileType = (fileName: string) => {
    let splitData = fileName.split('.');
    return isImage.includes(splitData[splitData.length - 1]);
  };

  const FieldComponent = (setting: Settings, settingGroup: SettingsGroups) => {
    const isSelected = () => {
      return selectedSetting.Name == setting.Name;
    };

    const getRangeLabels = (max: number, num: number) => {
      let result = [];
      let part = max / (num - 1);
      for (let i = 0; i < max; i += part) {
        result.push(Math.round(i));
      }
      result.push(max);
      return result;
    };

    const multiSelectItemRender = (
      li: React.ReactElement<HTMLLIElement>,
      itemProps: ListItemProps,
    ) => {
      const itemChildren = (
        <span>
          <input
            type="checkbox"
            name={itemProps.dataItem}
            checked={itemProps.selected}
            onChange={(event: any) => itemProps.onClick(itemProps.index, event)}
          />
          &nbsp;{li.props.children}
        </span>
      );
      return React.cloneElement(li, li.props, itemChildren);
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file && validateInputFileType(file?.name)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFileUploadingStatus(true);
          setSelectedFileName(selectedSetting.MediaName);

          let fullFilePath =
            featureFileFolderPath.FilePath + selectedSetting.MediaName;

          uploadFileToServer(dispatch, fullFilePath, reader.result);
        };

        reader.readAsDataURL(file);
      } else {
        setNotificationMessage('INVALID_FILE_FORMAT');
        displayCommandSend(true);
      }
    };

    switch (setting.FieldType) {
      case FieldType.RadioButton:
      case FieldType.FixedChoice:
        return (
          <DynamicDropDownList
            className={classes.fieldComponent}
            onFocus={() => setSelectedSetting(setting)}
            data={setting.FixedChoices.map(
              (choice: FixedChoice) => choice.FixedChoiceValue,
            )}
            value={setting.InitValue}
            onChange={(event: DropDownListChangeEvent) => {
              updateSetting(event.value, setting, settingGroup);
            }}
            width={650}
          />
        );
      case FieldType.Color:
        return (
          <div className={classes.colorPicker}>
            <ColorPicker
              size="small"
              fillMode={isSelected() ? 'outline' : 'solid'}
              rounded="small"
              view="combo"
              value={setting.InitValue == '' ? undefined : setting.InitValue}
              onChange={(event: ColorPickerChangeEvent) => {
                updateSetting(event.value, setting, settingGroup);
              }}
              onFocus={() => setSelectedSetting(setting)}
            />
          </div>
        );
      case FieldType.CheckBox:
        const value = checkBoxState.value;
        const selected = value.length;
        return (
          <MultiSelect
            size={'small'}
            onFocus={() => setSelectedSetting(setting)}
            className={classes.fieldComponent}
            data={setting.FixedChoices.map(
              (choice: FixedChoice) => choice.FixedChoiceValue,
            )}
            itemRender={multiSelectItemRender}
            autoClose={false}
            value={value}
            onChange={(event: MultiSelectChangeEvent) => {
              handleCheckBoxMultiSelectChange(event);
              updateSetting(event.value.join(','), setting, settingGroup);
            }}
            tags={
              selected > 0
                ? [{ text: `${selected} items selected`, data: [...value] }]
                : []
            }
          />
        );
      case FieldType.TextBox:
        return (
          <Input
            onFocus={() => setSelectedSetting(setting)}
            className={classes.fieldComponent}
            value={setting.InitValue}
            onChange={(event: InputChangeEvent) => {
              updateSetting(event.value, setting, settingGroup);
            }}
          />
        );
      case FieldType.Slider:
        return (
          <RangeSlider
            className={classes.rangeSlider}
            value={{
              start: Number(setting.InitValue.split(',')[0]),
              end: Number(setting.InitValue.split(',')[1]),
            }}
            step={1}
            min={Number(setting.FixedChoices[0].FixedChoiceRange.split(',')[0])}
            max={Number(setting.FixedChoices[1].FixedChoiceRange.split(',')[1])}
            onChange={(event: RangeSliderChangeEvent) => {
              updateSetting(
                Math.round(event.value.start) +
                  ',' +
                  Math.round(event.value.end),
                setting,
                settingGroup,
              );
              setSelectedSetting(setting);
            }}
          >
            {getRangeLabels(
              Number(setting.FixedChoices[1].FixedChoiceRange.split(',')[1]),
              5,
            ).map((perc, i) => (
              <SliderLabel key={i} position={perc}>
                {perc.toString()}
              </SliderLabel>
            ))}
          </RangeSlider>
        );
      case FieldType.Path:
        var imagePath =
          setting.InitValue != '' ? setting.InitValue.split('/').pop() : '';
        return (
          <div>
            <Input
              className={classes.fieldComponent}
              style={{ width: '85%' }}
              value={imagePath}
              disabled={true}
            />
            {isFileUploading ? (
              <Loader size="medium" type={'infinite-spinner'} />
            ) : (
              <Button
                className={classes.fieldComponent}
                style={{ width: '15%' }}
                onClick={() => handleClick(setting, settingGroup)}
                svgIcon={uploadIcon}
              />
            )}
            <input
              type="file"
              accept=".png"
              style={{ display: 'none' }}
              ref={inputRef}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleImageChange(e);
              }}
            />
          </div>
        );
      default:
        break;
    }
  };

  const handleClick = (setting: Settings, settingsGroup: SettingsGroups) => {
    setSelectedSetting(setting);
    setSelectedSettingGroup(settingsGroup);
    inputRef.current?.click();
  };

  const displayCommandRequestResult = (message: string) => {
    setNotificationMessage(message);
    setIsCommandSentSuccessfully(true);
    displayCommandSend(true);
  };

  const getParameters = () => {
    return JSON.stringify(modifiedConfigFeatures);
  };

  const setSendToSiteNumberCommand = (
    command: SendToSiteNumbersCommandInfo,
  ) => {
    let commandInfo: SendToSiteNumbersCommandInfo = {
      Division: command.Division,
      SiteNumbers: command.SiteNumbers,
      CommandInfo: {
        Command: command.CommandInfo.Command,
        Parameters: getParameters(),
      },
    };
    sendToSiteNumberCommand(dispatch, commandInfo);
  };

  const setSendToNodeGroupsCommand = (command: SendToNodeGroupsCommandInfo) => {
    let commandInfo: SendToNodeGroupsCommandInfo = {
      Division: command.Division,
      SiteNumber: command.SiteNumber,
      NodeGroups: command.NodeGroups,
      CommandInfo: {
        Command: command.CommandInfo.Command,
        Parameters: getParameters(),
      },
    };
    sendToNodeGroupsCommand(dispatch, commandInfo);
  };

  const setSendToLanesCommand = (command: SendToLanesCommandInfo) => {
    let commandInfo: SendToLanesCommandInfo = {
      Division: command.Division,
      SiteNumber: command.SiteNumber,
      NodeGroup: command.NodeGroup,
      LaneNumbers: command.LaneNumbers,
      CommandInfo: {
        Command: command.CommandInfo.Command,
        Parameters: getParameters(),
      },
    };
    sendToLanesCommand(dispatch, commandInfo);
  };

  const setSendToDivisionCommand = (command: SendToDivisionCommandInfo) => {
    let commandInfo: SendToDivisionCommandInfo = {
      Divisions: command.Divisions,
      CommandInfo: {
        Command: command.CommandInfo.Command,
        Parameters: getParameters(),
      },
    };
    sendToDivisionCommand(dispatch, commandInfo);
  };

  const [commandSend, displayCommandSend] = React.useState(false);

  useEffect(() => {
    let timeoutId: any;
    if (commandSend) {
      resetAllSendCommandResult(dispatch);
      timeoutId = setTimeout(() => {
        displayCommandSend(false);
        setIsCommandSentSuccessfully(false);
      }, 1000);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [commandSend]);

  const inputRef = React.useRef<HTMLInputElement>(null);

  return (
    <div>
      <div className={classes.container}>
        <div className={classes.featureListBoxContainer}>
          <div className={classes.featureListBoxView}>
            <Typography variant="h6" className={classes.featureHeaderLabel}>
              {GetString('PAGE_TITLE_FEATURES')}
            </Typography>
            <ListBox
              className={classes.featureListBox}
              data={featureNameList}
              textField="Name"
              selectedField={SELECTED_FIELD}
              onItemClick={(e: ListBoxItemClickEvent) => handleFeatureClick(e)}
            />
          </div>
        </div>
        <div className={classes.settingsGroupContainer}>
          <GridLayout
            className={classes.gridLayout}
            gap={{ rows: 2, cols: 1 }}
            rows={[{ height: '85%' }, { height: '15%' }]}
            cols={[{ width: '50%' }]}
          >
            <GridLayoutItem
              row={1}
              col={1}
              className={classes.gridLayoutItemSetting}
            >
              {selectedSettingsGroup.map(settingGroup => (
                <PanelBar key={settingGroup.Name + settingGroup.ListName}>
                  <PanelBarItem
                    expanded={true}
                    title={settingGroup.ListName}
                    key={settingGroup.Name + settingGroup.ListName}
                  >
                    {settingGroup.Settings.map(setting => (
                      <div
                        className={classes.settingListContainer}
                        key={setting.Name + setting.ListName}
                      >
                        <div
                          className={clsx(
                            classes.settingButton,
                            selectedSetting.Name == setting.Name
                              ? classes.selectedSetting
                              : classes.notSelectedSetting,
                          )}
                          onClick={() => setSelectedSetting(setting)}
                        >
                          <Label className={classes.settingButtonLabel}>
                            {setting.ListName}
                          </Label>
                        </div>

                        <div className={classes.fieldComponentContainer}>
                          {FieldComponent(setting, settingGroup)}
                        </div>
                      </div>
                    ))}
                  </PanelBarItem>
                </PanelBar>
              ))}
            </GridLayoutItem>
            <GridLayoutItem
              row={2}
              col={1}
              className={classes.settingDescription}
            >
              <Label className={classes.settingDescriptionHeaderLabel}>
                {selectedSetting.ListName}
              </Label>
              {selectedSetting.Description.split('\\r\\n').map(
                (label: string) => (
                  <Label
                    className={classes.settingDescriptionLabel}
                    key={label}
                  >
                    {label}
                  </Label>
                ),
              )}
            </GridLayoutItem>
          </GridLayout>
        </div>
      </div>
      <div>
        <NodeSelection
          title={'SELECT_LANES_TO_APPLY_CONFIGURATION'}
          command={'APPLY_CONFIGURATION'}
          setSendToSiteNumberCommand={setSendToSiteNumberCommand}
          setSendToNodeGroupsCommand={setSendToNodeGroupsCommand}
          setSendToLanesCommand={setSendToLanesCommand}
          buttonTitleKey="APPLY_BUTTON"
          disabled={modifiedConfigFeatures.length == 0}
          setSendToDivisionCommand={setSendToDivisionCommand}
          resetSelectionAfterSentSuccess={isCommandSentSuccessfully}
        />
      </div>
      <Fade>
        <NotificationGroup className={classes.bottomRight}>
          {commandSend && (
            <Notification
              className={classes.send}
              type={{
                style: isCommandSentSuccessfully ? 'success' : 'error',
                icon: true,
              }}
              closable={true}
            >
              <StringResourceManager stringKey={notificationMessage} />
            </Notification>
          )}
        </NotificationGroup>
      </Fade>
    </div>
  );
};
